import { Slider, Stack, TextField, Typography } from '@mui/material'
import { FieldDef } from '../types'

interface Props {
  field: FieldDef
  value: Record<string, number>
  onChange: (v: Record<string, number>) => void
}

export default function DimensionsWidget({ field, value, onChange }: Props) {
  const axes = field.axes || []
  const safe = value || {}

  const update = (axis: string, v: number) => onChange({ ...safe, [axis]: Math.max(0, Math.min(100, v)) })

  return (
    <Stack spacing={1.5}>
      <Typography variant="caption" color="text.secondary">
        {field.label}
      </Typography>
      {axes.map((axis) => (
        <Stack key={axis} direction="row" spacing={2} alignItems="center">
          <Typography variant="body2" sx={{ minWidth: 160 }}>
            {axis}
          </Typography>
          <Slider
            value={safe[axis] ?? 0}
            onChange={(_, v) => update(axis, v as number)}
            min={0}
            max={100}
            valueLabelDisplay="auto"
            sx={{ flex: 1 }}
          />
          <TextField
            type="number"
            value={safe[axis] ?? 0}
            onChange={(e) => update(axis, e.target.value === '' ? 0 : Number(e.target.value))}
            size="small"
            sx={{ width: 80 }}
            inputProps={{ min: 0, max: 100 }}
          />
        </Stack>
      ))}
    </Stack>
  )
}
